import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { CheckCircle2, Play } from 'lucide-react';
const TESTIMONIALS = [{
  image: 'https://i.pravatar.cc/150?img=47',
  name: 'María G.',
  location: 'Buenos Aires',
  title: 'Bajé 6kg en 8 semanas',
  text: 'Nunca había podido organizarme con la comida. Ahora sé exactamente qué cocinar y ya no vivo improvisando.',
  hasVideo: true
}, {
  image: 'https://i.pravatar.cc/150?img=11',
  name: 'Roberto P.',
  location: 'Córdoba',
  title: 'Bajé el colesterol 40 puntos',
  text: 'Mi médico me felicitó por el cambio. Este kit me simplificó completamente la alimentación.',
  hasVideo: false
}, {
  image: 'https://i.pravatar.cc/150?img=33',
  name: 'Lucas C.',
  location: 'Rosario',
  title: 'Aumenté 4kg de músculo',
  text: 'Entrenaba bien pero comía cualquier cosa. Las recetas proteicas cambiaron mis resultados.',
  hasVideo: true
}];
export function Testimonials() {
  return <section className="py-24 bg-cream" data-id="element-951">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-952">
        <div className="text-center mb-16" data-id="element-953">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4 tracking-tight" data-id="element-954">
            Resultados reales de personas reales
          </h2>
          <p className="text-lg text-ink-light font-light" data-id="element-955">
            Descubrí cómo nuestros kits están transformando la alimentación de
            miles de personas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-956">
          {TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className="bg-white rounded-3xl p-8 shadow-premium border border-ink/5 flex flex-col relative overflow-hidden" data-id="element-957">
              {t.hasVideo && <div className="absolute top-6 right-6 w-10 h-10 bg-combo-green/10 rounded-full flex items-center justify-center cursor-pointer hover:bg-combo-green/20 transition-colors" data-id="element-958">
                  <Play className="w-4 h-4 text-combo-green ml-0.5" data-id="element-959" />
                </div>}
              <div className="flex gap-1 mb-6" data-id="element-960">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-961" />)}
              </div>
              <h4 className="font-bold text-xl text-ink mb-4" data-id="element-962">"{t.title}"</h4>
              <p className="text-ink-light leading-relaxed italic flex-grow mb-8 font-light" data-id="element-963">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-ink/5" data-id="element-964">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover shadow-sm" data-id="element-965" />
                <div data-id="element-966">
                  <div className="font-bold text-ink flex items-center gap-1" data-id="element-967">
                    {t.name}
                    <CheckCircle2 className="w-3.5 h-3.5 text-combo-green" data-id="element-968" />
                  </div>
                  <div className="text-xs text-ink-light flex items-center gap-1" data-id="element-969">
                    {t.location} • Compra verificada
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-970">
          <div className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow-sm border border-ink/5 font-medium text-ink text-sm" data-id="element-971">
            <Star className="w-4 h-4 text-gold fill-gold" data-id="element-972" />
            +7000 clientes · Valoración promedio 5.0
          </div>
        </motion.div>
      </div>
    </section>;
}